export default __webpack_public_path__ + "static/media/SWT1110.34I-40348_-23913_0.d50e34ad.jpg";